import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import FullWidthContainer from "../../components/FullWidthContainer";
import Button from "../../components/ui-lib/buttons/Button";
import VacancyList from "../../components/vacancy/VacancyList";
import { useVacanciesState } from "../../states/vacancy-state/vacancy.state";
import { SetItemsAction } from "../../helpers/state-helpers/crud-actions";
import useAuthData from "../../auth/useAuthData";
import { useVacancyApi } from "../../apis/vacancy-api";
import { useQueryParams } from "../../hooks/useQueryParams";
import { useMemo } from "react";
import { VacancyFilterParams } from "../../models/filters";
import VacancyFilters from "../../components/vacancy/VacancyFilters";

function SchoolView() {
  const navigate = useNavigate();
  const { currentSchool: school } = useAuthData();
  const { dispatch } = useVacanciesState();
  const { getVacanciesOfSchool } = useVacancyApi();
  const { getQueryParamGroup } = useQueryParams();
  const queryParams = useMemo(
    () => getQueryParamGroup(VacancyFilterParams),
    [getQueryParamGroup],
  );

  useQuery(["vacancies", school?.id, queryParams], {
    queryFn: () => getVacanciesOfSchool(school!.id, queryParams),
    onSuccess: (values) => dispatch(new SetItemsAction(values)),
    enabled: !!dispatch && !!school,
    refetchInterval: 15000,
  });

  const navigateToCreateVacancy = () => navigate("/vacancy");

  return (
    <>
      <FullWidthContainer className="bg-nid_grey">
        <header className="mb-10 flex flex-col items-start md:flex-row md:justify-between">
          <VacancyFilters />
          <Button className="mb-2 md:mb-0" onClick={navigateToCreateVacancy}>
            Ausfall erfassen
          </Button>
        </header>
        <main>
          <section>
            <VacancyList></VacancyList>
          </section>
        </main>
      </FullWidthContainer>
    </>
  );
}

export default SchoolView;
